import { ThemeOptions, createMuiTheme } from "@material-ui/core"
import {
	green,
	deepOrange,
	lightBlue,
	orange,
	indigo,
} from "@material-ui/core/colors"

export const defaultTheme: ThemeOptions = {
	...createMuiTheme(),
	palette: {
		primary: {
			main: indigo["500"],
		},
		secondary: {
			main: indigo["300"],
		},
	},
}

export const applyTheme: ThemeOptions = {
	...defaultTheme,
	palette: {
		primary: {
			main: green["800"],
		},
		secondary: {
			main: green["200"],
		},
	},
}

export const discoverTheme: ThemeOptions = {
	...defaultTheme,
	palette: {
		primary: {
			main: orange["500"],
		},
		secondary: {
			main: orange["200"],
		},
	},
}

export const planActionTheme: ThemeOptions = {
	...defaultTheme,
	palette: {
		primary: {
			main: lightBlue["800"],
		},
		secondary: {
			main: lightBlue["200"],
		},
	},
}

export const settingsTheme: ThemeOptions = {
	...defaultTheme,
	palette: {
		primary: {
			main: deepOrange.A700,
		},
		secondary: {
			main: deepOrange["300"],
		},
	},
}
